module.exports = __webpack_public_path__ + "static/img/Download_App_Store.fbf19c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Download_App_Store.svg
// module id = r4CE
// module chunks = 1